import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: "/", label: "首页" },
    { to: "/category/redai-haidao", label: "目的地" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="w-8 h-8 flex items-center justify-center text-lg">
              <i className="ri-flight-takeoff-line text-primary-500"></i>
            </span>
            <span className={`font-heading text-xl font-bold transition-colors ${
              scrolled ? "text-foreground-900" : "text-white"
            }`}>
              亚洲天堂
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? scrolled
                      ? "text-primary-500"
                      : "text-primary-300"
                    : scrolled
                    ? "text-foreground-700 hover:text-primary-500"
                    : "text-white/80 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? "text-foreground-900" : "text-white"
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4">
            <div className="flex flex-col gap-3 px-4">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-medium px-3 py-2 rounded-lg transition-colors cursor-pointer ${
                    location.pathname === link.to
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}